import { reducer as toastr } from 'react-redux-toastr'
import { reducer as formReducer } from 'redux-form'
import carrierServicesReducer from '../redux/storeConfig/slices/slice.carrierServices'
import admins from './adminsReducer'
import agencies from './agenciesReducer'
import alertReducer from './alertReducer'
import artworkFamilyReducer from './artworkFamilyReducer'
import artworkPreviewReducer from './artworkPreviewReducer'
import artworks from './artworkReducer'
import audits from './auditsReducer'
import AuthorizedAdminEmailDomainsReducer from './AuthorizedAdminEmailDomainsReducer'
import blacklistIpsReducer from './blacklistIpsReducer'
import bundleGroupReducer from './bundleGroupReducer'
import bundles from './bundleReducer'
import buttonsReducer from './buttonsReducer.js'
import cardPaymentsReducer from './cardPaymentsReducer'
import carrierIds from './carrierIdsReducer'
import carrierOptionsReducer from './carrierOptionsReducer.js'
import carrierRatesMultiBox from './carrierRatesMultiBoxReducer'
import carrierRates from './carrierRatesReducer'
import carriers from './carriersReducer'
import cartsReducer from './cartsReducer'
import categories from './categoriesReducer'
import ccDataPointsReducer from './ccDataPointsReducer'
import checkoutFormReducer from './checkoutFormReducer'
import clientAdminsByUserReducer from './clientAdminsByUserReducer'
import clientAdminsReducer from './clientAdminsReducer'
import clientImagesReducer from './clientImagesReducer'
import clientPortalsReducer from './clientPortalsReducer'
import clientsCcDataPoints from './clientsCcDataPoints'
import clients from './clientsReducer'
import configurableOptions from './configurableOptionsReducer'
import configWizardForm from './configWizardFormReducer'
import creditBalancesReducer from './creditBalancesReducer'
import creditsCoopBalancesByTagReducer from './creditsCoopBalancesByTagReducer'
import credits from './creditsReducer'
import current from './currentReducer'
import customerGroupReducer from './customerGroupReducer'
import customerGroupRulesReducer from './customerGroupRulesReducer'
import customerGroupsForUserReducer from './customerGroupsForUserReducer'
import dashboardReducer from './dashboardReducer'
import digitalProofingItems from './digitalProofingReducer'
import domains from './domainsReducer'
import dropshipBatchesReducer from './dropshipBatchesReducer'
import dropshipImagesReducer from './dropshipImagesReducer'
import dropshipTemplatesReducer from './dropshipTemplatesReducer'
import errors from './errorsReducer'
import externalAccountsReducer from './externalAccountsReducer'
import getLastReminderSent from './getLastReminderSent'
import goodsReceiptReducer from './goodsReceiptReducer'
import goodsReceiptsLogsReducer from './goodsReceiptsLogsReducer'
import images from './imagesReducer'
import integrations from './integrationsReducer'
import inventoryLog from './inventoryLogReducer'
import layout from './layout'
import loading from './loadingReducer'
import locationCategoryProductsReducer from './locationCategoryProductsReducer'
import locationGroupsReducer from './locationGroupsReducer'
import locations from './locationsReducer'
import { logsErrorReducer } from './logsErrorReducer'
import managedAddressReducer from './managedAddressReducer'
import menusReducer from './menusReducer'
import mfReducer from './mfReducer'
import navbar from './navbar'
import navigation from './navigationReducer'
import orderAfterRefundsReducer from './orderAfterRefundsReducer'
import orderErrorsReducer from './orderErrorsReducer'

import order from './orderReducer'
import orderRefundStatusesReducer from './orderRefundStatusesReducer'
import splitOrderReducer from './orderSplitReducer'
import orderSplittedSubOrdersReducer from './orderSplittedSubOrdersReducer'
import orders from './ordersReducer'
import pages from './pagesReducer'
import paginatedReducer from './paginatedReducer'
import pendingOrdersReducer from './pendingOrdersReducer'
import periods from './periodsReducer'
import permissions from './permissionReducer'
import portalAccountsReducer from './portalAccountsReducer'
import portalPortalTagsReducer from './portalPortalTagsReducer'

import portals from './portalsReducer'
import portalTagSetsReducer from './portalTagSetsReducer'
import portalTagsReducer from './portalTagsReducer'
import portalTraditionalDeliveryAddressReducer from './portalTraditionalDeliveryAddressReducer'
import portalUsersReducer from './portalUsersReducer'
import productClientsReducer from './productClientsReducer'
import productConfigurableVariantsReducer from './productConfigurableVariantsReducer'
import productDetailsWizardReducer from './productDetailsWizardReducer.js'
import productDimensionPresetsReducer from './productDimensionsReducer.js'
import productLocationsReducer from './productLocationsReducer'
import productPortalsReducer from './productPortalsReducer'
import productShippingBoxReducer from './productShippingBoxReducer'
import productShippingGroupReducer from './productShippingGroupReducer'
import productShippingOriginReducer from './productShippingOriginReducer'
import productShqPackingReducer from './productShqPackingReducer'
import productSkusReducer from './productSkusReducer'
import products from './productsReducer'
import promotionCodesReducer from './promotionCodesReducer'
import promotionRulesReducer from './promotionRulesReducer'
import promotions from './promotionsReducer'
import promotionValidationsReducer from './promotionValidationsReducer'
import purchaseLimitsReducer from './purchaseLimitsReducer.js'
import purchaseOrderItemReducer from './purchaseOrderItemReducer'
import purchaseOrderReducer from './purchaseOrderReducer'
import refundOrderReducer from './refundOrdersReducer'
import refunds from './refundsReducer'
import refundsSummaryReducer from './refundsSummaryReducer'
import roles from './roleReducer'
import sendBalanceRemindersReducer from './sendBalanceRemindersReducer'
import settings from './settingsReducer'
import shipFromAddresses from './shipFromAddressesReducer'
import shipmentReducer from './shipmentReducer'
import shipperHqReducer from './shipperHqReducer'
import shippingDimensionsReducer from './shippingDimensionsReducer'
import shippingLabelReducer from './shippingLabelReducer'
import shippingTypesReducer from './shippingTypesReducer'
import showPortalTagSetsReducer from './showPortalTagSetsReducer'
import sortedSkusReducer from './sortedSkusReducer'
import status from './statusReducer'
import stocks from './stocksReducer'
import subCategoriesReducer from './subCategoriesReducer'
import subOrderReducer from './subOrderReducer'
import systemSettingsReducer from './systemSettingsReducer'
import tags from './tagsReducer'
import templateFormsReducer from './templateFormsReducer'
import templates from './templatesReducer'
import thirdPartyBillings from './thirdPartyBillingsReducer'
import tierPriceReducer from './tierPriceReducer'
import uploadHistoryReducer from './uploadHistoryReducer'
import uploadResultsReducer from './uploadResultsReducer'
import userDetailsReducer from './userDetailsReducer.js'
import userPortalsCustomerGroupsReducer from './userPortalsCustomerGroupsReducer'
import users from './usersReducer'
import vendors from './vendorsReducer'
import warehouseReducer from './warehouseReducer'
import whitelistIpsReducer from './whitelistIpsReducer'

export default {
  admins,
  agencies,
  all_paginated_models: paginatedReducer,
  audits,
  authorized_admin_email_domains: AuthorizedAdminEmailDomainsReducer,
  artworks,
  artwork_families: artworkFamilyReducer,
  artwork_preview: artworkPreviewReducer,
  blacklisted_ips: blacklistIpsReducer,
  bundle_groups: bundleGroupReducer,
  bundles,
  buttons: buttonsReducer,
  card_payments: cardPaymentsReducer,
  carriers,
  carrierIds,
  carrierOptions: carrierOptionsReducer,
  carrierRates,
  carrierRatesMultiBox,
  carrierServices: carrierServicesReducer,
  carts: cartsReducer,
  categories,
  ccdps: clientsCcDataPoints,
  cc_data_points: ccDataPointsReducer,
  checkout_forms: checkoutFormReducer,
  client_admins: clientAdminsReducer,
  client_admins_by_user: clientAdminsByUserReducer,
  client_images: clientImagesReducer,
  client_portals: clientPortalsReducer,
  clients,
  configurable_options: configurableOptions,
  configWizardForm,
  coop_balances_by_tag: creditsCoopBalancesByTagReducer,
  credit_balances: creditBalancesReducer,
  credits,
  current,
  customer_group_rules: customerGroupRulesReducer,
  customer_groups: customerGroupReducer,
  customer_groups_for_user: customerGroupsForUserReducer,
  dashboard: dashboardReducer,
  digitalProofingItems,
  domains,
  dropship_batches: dropshipBatchesReducer,
  dropship_images: dropshipImagesReducer,
  dropship_templates: dropshipTemplatesReducer,
  errors,
  external_accounts: externalAccountsReducer,
  form: formReducer,
  funding_tags: portalPortalTagsReducer,
  get_last_reminder_sent: getLastReminderSent,
  goods_receipt: goodsReceiptReducer,
  goods_receipts_logs: goodsReceiptsLogsReducer,
  images,
  loading,
  locations,
  locationGroups: locationGroupsReducer,
  location_category_products: locationCategoryProductsReducer,
  logs_error: logsErrorReducer,
  mf: mfReducer,
  menu_items: menusReducer,
  navigation,
  orders,
  order,
  order_after_refunds: orderAfterRefundsReducer,
  order_errors_count: orderErrorsReducer,
  order_refund_statuses: orderRefundStatusesReducer,
  pages,
  pending_orders: pendingOrdersReducer,
  periods,
  permissions,
  portal_tags: portalTagsReducer,
  portal_users: portalUsersReducer,
  portals,
  portal_traditional_delivery_addresses: portalTraditionalDeliveryAddressReducer,
  portal_accounts: portalAccountsReducer,
  product_clients: productClientsReducer,
  product_configurable_variants: productConfigurableVariantsReducer,
  productDetailsWizard: productDetailsWizardReducer,
  productDimensionPresets: productDimensionPresetsReducer,
  product_locations: productLocationsReducer,
  product_packing_rule: productShqPackingReducer,
  product_portals: productPortalsReducer,
  product_shipping_groups: productShippingGroupReducer,
  product_shipping_origins: productShippingOriginReducer,
  product_shipping_boxes: productShippingBoxReducer,
  product_skus: productSkusReducer,
  product_skus_sorted: sortedSkusReducer,
  products,
  promotion_rules: promotionRulesReducer,
  promotion_codes: promotionCodesReducer,
  promotion_validations: promotionValidationsReducer,
  promotions,
  purchase_order_items: purchaseOrderItemReducer,
  purchase_orders: purchaseOrderReducer,
  purchase_limits: purchaseLimitsReducer,
  // purchase_orders:            purchaseOrderReducer,
  refund_orders: refundOrderReducer,
  refunds,
  refunds_summary: refundsSummaryReducer,
  roles,
  send_balance_reminders: sendBalanceRemindersReducer,
  settings,
  shipping_labels: shippingLabelReducer,
  shipperHq: shipperHqReducer,
  shipping_dimensions: shippingDimensionsReducer,
  shipment_details: shipmentReducer,
  shippingTypes: shippingTypesReducer,
  show_tag_sets: showPortalTagSetsReducer,
  managed_addresses: managedAddressReducer,
  split_order: splitOrderReducer,
  splitted_sub_orders: orderSplittedSubOrdersReducer,
  status,
  stocks,
  sub_categories: subCategoriesReducer,
  sub_orders: subOrderReducer,
  system_settings: systemSettingsReducer,
  sweet_alert: alertReducer,
  tags,
  template_form: templateFormsReducer,
  tier_price: tierPriceReducer,
  tag_sets: portalTagSetsReducer,
  templates,
  thirdPartyBillings,
  toastr,
  uploaded_results: uploadResultsReducer,
  upload_history: uploadHistoryReducer,
  user_portals_customer_groups: userPortalsCustomerGroupsReducer,
  user_details: userDetailsReducer,
  users,
  vendors,
  warehouseState: warehouseReducer,
  inventoryLog,
  shipFromAddresses,
  whitelisted_ips: whitelistIpsReducer,
  integrations,

  // vuexy
  navbar,
  layout
}
